var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survival-plot-container"},[_c('div',{staticClass:"plot-card"},[_c('div',{staticClass:"plot-header"},[_c('span',{staticClass:"gene-title"},[_vm._v(_vm._s(_vm.gene))])]),_c('div',{staticClass:"plot-body"},[_c('Plot',{attrs:{"data":_vm.data,"layout":_vm.layout,"config":_vm.config}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }